import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";

function InsureesTableData({ data, selectedIds, onToggle, onEdit, onDelete }) {
  const columns = [
    { Header: "", accessor: "checkbox", align: "center", width: "2%" },
    { Header: "Full Name", accessor: "name", align: "left" },
    { Header: "Gender", accessor: "gender", align: "center" },
    { Header: "Date of Birth", accessor: "dob", align: "left" },
    { Header: "Relationship", accessor: "relationship", align: "left" },
    { Header: "Policy Code", accessor: "policyCode", align: "left" },
    { Header: "Scheme", accessor: "policyTypeName", align: "left" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((a) => ({
    checkbox: (
      <Checkbox size="small" checked={selectedIds.includes(a.id)} onChange={() => onToggle(a.id)} />
    ),
    name: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {a.name}
      </MDTypography>
    ),
    gender: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.gender}
      </MDTypography>
    ),
    dob: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.dateOfBirth || "N/A"}
      </MDTypography>
    ),
    relationship: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.relationship}
      </MDTypography>
    ),
    policyCode: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.policyCode || "No Policy"}
      </MDTypography>
    ),
    policyTypeName: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.policyTypeName || "No Policy Type"}
      </MDTypography>
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(a)}>
          <Icon fontSize="small">edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(a)}>
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      canSearch={false}
      size="small"
    />
  );
}

InsureesTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default InsureesTableData;
